module.exports = __webpack_public_path__ + "static/media/iconMenuList.146e7be3.svg";